{
  "claimsList": {
    "config": {
      "dataSource": [],
      "columnHeaders": [
        {
          "title": "",
          "field": "headerTemp"
        },
        {
          "title": "NAMED INSURED",
          "field": "namedInsured"
        },
        {
          "title": "POLICY NUMBER",
          "field": "policyNumber"
        },
        {
          "title": "POLICY PERIOD",
          "field": "policyPeriod"
        },
        {
          "title": "LINE OF BUSINESS",
          "field": "lineOfBusiness"
        },
        {
          "title": "PRICING PLAN",
          "field": "pricingPlan"
        },
        {
          "title": "",
          "field": "icon"
        }
      ],
      "dataSource1": [
        {
          "usersOfAccount": "Amy Sputzzurc",
          "role": "Billing Coordinator"
        },
        {
          "usersOfAccount": "Amy Sputzzurc",
          "role": "Billing Coordinator"
        },
        {
          "usersOfAccount": "Amy Sputzzurc",
          "role": "Billing Coordinator"
        },
        {
          "usersOfAccount": "Amy Sputzzurc",
          "role": "Billing Coordinator"
        },
        {
          "usersOfAccount": "Amy Sputzzurc",
          "role": "Billing Coordinator"
        }
      ],
      "columnHeaders1": [
        {
          "title": "",
          "field": "checkBox"
        },
        {
          "title": "USERS OF THE ACCOUNT",
          "field": "usersOfAccount"
        },
        {
          "title": "ROLE",
          "field": "role"
        }
      ]
    }
  }
}